import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';

// Models

import {
  RecordType,
  GeologicalSample,
  GeologicalSampleDetails,
} from '@models';

@Injectable({
  providedIn: 'root',
})
export class GeologicalSampleService {
  private http = inject(HttpClient);

  recordType = RecordType;
  kinkoHost = environment.kinkoHost;
  geologicalSampleDataset = environment.geologicalSampleDatasetId;

  endpoint = `${this.kinkoHost}/dataset/${this.geologicalSampleDataset}/record/`;

  getSample(id: string) {
    return this.http.get<GeologicalSample>(this.endpoint + id, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  updateSample(id: string, entry: GeologicalSample) {
    return this.http.put<GeologicalSampleDetails>(this.endpoint + id, entry, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    });
  }
}
